import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Container, Header, Footnote, Anchor } from 'Components/core';
import { colors } from 'Constants';

import InfoBox from 'Components/InfoBox';

// Images
import complexAndChronic from './images/complex-and-chronic.jpg';
import contactUs from './images/contact-us.jpg';
import everydayCare from './images/everyday-care.jpg';
import familyPlanning from './images/family-planning.jpg';
import AppStoreIOS from 'Images/store-icon-ios.png';
import AppStoreAndroid from 'Images/store-icon-android.png';

// State
import { Subscribe } from 'laco-react';
import { ApiStore } from 'Store';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
import { toArray } from 'Root/libs/array';
import { SubHeader, TitleHeader } from 'Components/core/Header';
 
function hexToRgb(hex, alpha) {
  return '#ffffff';
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(
      ${parseInt(result[1], 16)},
      ${parseInt(result[2], 16)},
      ${parseInt(result[3], 16)},
      ${alpha || 1})`
    : undefined;
}

const Table = styled.table`
margin-top:20px ;
 
  tr > * {
    padding: 8px;
    ${props => props.center && css(`text-align: center;`)}
  }

  th {
    font-weight: normal;
    text-align: left;
  }

  tr:nth-child(1) {
    th:nth-child(1) {
      background-color: ${props => props.color1};
      color: ${colors.textOnAccent};
    }

    th:nth-child(3n + 2) {
      background-color: ${props => props.color2};
      color: ${colors.textOnAccent};
    }

    th:nth-child(3n + 3) {
      background-color: ${props => props.color3};
      color: ${colors.textOnAccent};
    }
    th:nth-child(3n + 4) {
      background-color: ${props => props.color4};
      color: ${colors.textOnAccent};
    }
  }

  .row:nth-child(even) {
    background-color: #e2f2f2;
  }

  tr {
    > td:nth-child(1) {
      background-color: ${props => hexToRgb(props.color1, 0.2)};
    }

    > td:nth-child(3n + 2) {
      background-color: ${props => hexToRgb(props.color2, 0.2)};
    }

    > td:nth-child(3n + 3) {
      background-color: ${props => hexToRgb(props.color3, 0.2)};
    }

    > td:nth-child(3n + 4) {
      background-color: ${props => hexToRgb(props.color4, 0.2)};
    }
  }
`;

const RightContainer=styled.div`
  flex:1;
  background-color:${colors.accentLight} ;
  display:flex ;
  flex-direction:column ;
  justify-content:center;
  align-items:center ;
  padding-top:40px ;
  padding-bottom:40px ;
div
{
  margin-top:8px ;
  text-align:left ;
 
  width:80%;
  margin-left:30px;
  


  
  
}

`


export default () => {

  useEffect(()=>{
    Api.recordAcitity(CODES.Plan_Details);
  },[]);

  return  (
    <Subscribe to={[ApiStore]}>
      {state => {
        return (
          <Container
            seperation="32px"
            column
            maxWidth
            style={{ margin: 'auto', padding: '32px' }}
          >
          
            <div style={{display:'flex',justifyContent:'space-between',}}>
              <div style={{flex:1}}>
  <TitleHeader>Your plan <SubHeader>details</SubHeader></TitleHeader>
              </div>
              <RightContainer>
                <div style={{fontWeight:'bold'}}>
                  {state?.brandInfo?.fullname}
                </div>
                <div>
             Student Health Insurance Plan {state?.name}
                </div>
                <div>
              Your network : {state?.networkName} 
                </div>
              </RightContainer>
            </div>
            {state?.asaPlan?.chart && <div>
       
              <div style={{fontSize:'1.4em',color:'#3477bc',fontWeight:'bold'}}>{state?.asaPlan?.chart.title}</div>
              <div>{state?.asaPlan?.chart.summary}</div>
              <div>
                <Table   border
                  color1="#081f65"
                  color2={'#081f65'}
                  color3="#081f65"
                  color4="#081f65">
                  <tbody>
                    {state?.asaPlan?.chart.table.tr.map(row=><tr>
                      {row.th && toArray(row.th).map(td=><th>{td}</th>)}
                      {row.td && toArray(row.td).map(td=><td>{td}</td>)}
                        
                    </tr>)}
                  </tbody>
                </Table>
                {state?.asaPlan?.chart.footNote && <Footnote>{state?.asaPlan?.chart.footNote}</Footnote>}
                {state?.asaPlan?.chart.footNotes && <Footnote>{state?.asaPlan?.chart.footNotes.footNote.map(text=><div>{text}</div>)}</Footnote>}
              </div>

            
            </div>}
            {state?.asaPlan?.outOfNetwork && <p dangerouslySetInnerHTML={{__html:state?.asaPlan?.outOfNetwork}}></p>}
            {state?.asaPlan?.extraParagraph && <p dangerouslySetInnerHTML={{__html:state?.asaPlan?.extraParagraph}}></p>}
            {state?.asaPlan?.referral && <p dangerouslySetInnerHTML={{__html:state?.asaPlan?.referral}}></p>}

            {state?.asaPlan?.footNotes?.footNote && <div>{toArray(state.asaPlan.footNotes.footNote).map(text=><Footnote>{text}</Footnote>)}</div> }
          </Container>
        );
      }}
    </Subscribe>
  );
};